import ClientDetails from './ClientDetails'
import CowEnvironment from './CowEnvironment'
import Culling from './Culling'
import CurrentMastitisSituation from './CurrentMastitisSituation'
import DetectionAndTreatmentOfClinicalCases from './DetectionAndTreatmentOfClinicalCases'
import DryCowStrategy from './DryCowStrategy'
import DryOffProcess from './DryOffProcess'
import MastitisControlMeasures from './MastitisControlMeasures'
import MastitisGoals from './MastitisGoals'
import MilkCultures from './MilkCultures'
import PreventiveHealthAndVaccination from './PreventiveHealthAndVaccination'
import ThisSeasonDryOff from './ThisSeasonDryOff'


export const DryCowSummaryComponents = {
  ClientDetails,
  CowEnvironment,
  Culling,
  CurrentMastitisSituation,
  DetectionAndTreatmentOfClinicalCases,
  DryCowStrategy,
  DryOffProcess,
  MastitisControlMeasures,
  MastitisGoals,
  MilkCultures,
  PreventiveHealthAndVaccination,
  ThisSeasonDryOff,
}
